import React, { useState } from 'react';
import CommonCard from '../atoms/CommonCard';
import axios from '../../../config/axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import ConfirmDialog from './ConfirmDialog';

interface Role {
  id: number;
  name: string;
  updatedOn: string;
  createdBy: string;
}

interface RoleCardProps {
  role: Role;
  onDelete: (id: number) => void;
}
// A component that displays role details with options to edit or delete the role.

const RoleCard: React.FC<RoleCardProps> = ({ role, onDelete }) => {
  const navigate = useNavigate();
  const [showDelete, setShowDelete] = useState(false);

  const confirmDelete = () => {
    setShowDelete(true);
  }
  const handleDelete = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(`/roles/delete/${role.id}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Role deleted successfully', { autoClose: 2000 });
      onDelete(role.id);
    } catch (err) {
      console.error(err);
    }
    finally {
      setShowDelete(false);
    }
  };

  return (
   <>
    <CommonCard
      id={role.id}
      title={role.name}
      entityType="Role"
      details={[
        { label: 'Updated on', value: role.updatedOn },
        { label: 'Created by', value: role.createdBy },
      ]}
      onEdit={() => navigate(`/edit_role/${role.id}`)}
      onDelete={confirmDelete}
      permissionName={'configurations'}
    />
     <ConfirmDialog
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onConfirm={handleDelete}
        title="Confirm delete"
        body={`Are you sure you want to delete the ${role.name}?`}
        confirmText="Delete"
      />
   </>
  );
};

export default RoleCard;
